var React = require('react');

function Moon (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"m3247.6 196.1c0 108.3-87.8 196.1-196.1 196.1-60.2 0-114-27.1-150-69.7 22.6 10.7 47.8 16.7 74.4 16.7 95.8 0 173.5-77.7 173.5-173.5 0-76.6-49.7-141.7-118.6-164.6 6.8-.7 13.7-1.1 20.7-1.1 108.3 0 196.1 87.8 196.1 196.1z","fill":"#ffeea9"}));
}

Moon.defaultProps = {"enableBackground":"new 0 0 4871 5156.7","viewBox":"0 0 4871 5156.7"};

module.exports = Moon;

Moon.default = Moon;
